import PropTypes from "prop-types";
import { Card as BootstrapCard } from "react-bootstrap";

import styles from "./Card.module.scss";

const Card = ({ className, children, style }) => (
  <BootstrapCard className={`${styles.card} ${className} border-0`} style={style}>
    {children}
  </BootstrapCard>
);

Card.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  children: PropTypes.node,
  style: PropTypes.shape({}),
};

Card.defaultProps = {
  className: "",
  children: null,
  style: {},
};

export default Card;
